import {Component, Input, OnInit} from '@angular/core';
import {AppComponent} from "../../app.component";
import {getFormatedSize, themesList} from "../../utils/parseUtils";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {ProfilePasswordChangeComponent} from "../profile-password-change/profile-password-change.component";
import {DialogCanvasComponent} from "../dialog-canvas/dialog-canvas.component";
import {ApiService} from "../../api.service";

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {

  quotaMax: string;
  quotaUsed: string;
  quotaPercent: string;
  private _userMenuOpened: boolean;
  public get userMenuOpened(): boolean {
    return this._userMenuOpened;
  }
  @Input() public set userMenuOpened(value: boolean) {
    this._userMenuOpened = value;
    if (value) {
      this.getQuota();
    }
  }
  private commonDialogConf = {
    autoFocus: false,
    // panelClass: 'common-dialog-form'
  };
  toggleAppereance = false;
  themesList: Array<object> = themesList;
  constructor(
    public apiService: ApiService,
    public application: AppComponent,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    //this.getQuota()
  }

  public getQuota() {
    this.apiService.checkQuota()
      .subscribe(
        (res) => this.handleQuotaResponse(res))
  }

  private handleQuotaResponse(quotaRes) {
    if (quotaRes.user_quota) {
      this.quotaMax = getFormatedSize(parseInt(quotaRes.user_quota, 10), 100);
      this.quotaUsed = getFormatedSize(parseInt(quotaRes.user_used, 10), 100);
      this.quotaPercent = Math.round(quotaRes.user_used / quotaRes.user_quota * 100) + '%';
    } else {
      this.quotaMax = getFormatedSize(parseInt(quotaRes.account_quota, 10), 100);
      this.quotaUsed = getFormatedSize(parseInt(quotaRes.account_used, 10), 100);
      this.quotaPercent = Math.round(quotaRes.account_used / quotaRes.account_quota * 100) + '%';
    }
  }

  openPasswordChange(event: MouseEvent): void {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      ...this.commonDialogConf,
      data: {
        application: this.application,
        state: 'profile-password-change'
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
  }

  openAppereance(event: MouseEvent): void {
    event.stopImmediatePropagation();
    this.toggleAppereance = !this.toggleAppereance
  }

  menuClosePrevent(event: MouseEvent): void {
    event.stopImmediatePropagation();
  }

  toggleToolbar(): void {
    this.application.bottomToolbar = this.application.bottomToolbar === 'Y' ? 'N' : 'Y';
  }

  openDocs(): void {
    window.open('https://docs.maytech.net/ftp-stream/ftp-stream-user-guide', '_blank')
  }

}
